import { defineStore } from "pinia";
import { MenuItemsModel } from '@/../../EshJSLib/models/MenuItemsModel';
import { getMenuService } from '@/../../EshJSLib/services/menuService';
import { hasPermission } from "@/../../EshJSLib/services/securityServices";
const submenuList = new MenuItemsModel();
export const menuItemStore = defineStore('submenuList', {
    state: () => ({
        submenuList: submenuList

    }),
    getters: {
        getMenuItems: (state) => state.submenuList
    },
    actions: {
        fetchMenuItems: async function (id) {
           let menuobj = localStorage.getItem('menu')
            if (menuobj != null) {
                this.submenuList.items = JSON.parse(localStorage.getItem('menu'))

            } else {
                getMenuService(id).then(async data => {
                    this.submenuList.items = data.data;
                    if (await hasPermission('admin')) { 
                        this.submenuList.items.push(
                           {
                                "label": "admin",
                                "url": "/admin/admin",
                                "image": "direct-download.png",
                                "active": true,
                                "submenu": []
                            }
                       ) 
                    }
                    localStorage.setItem('menu', JSON.stringify(this.submenuList.items))
                });
            }

        }
    },
})